import { z } from "zod";

export const BaseStatisticsOutputItemSchema = z.object({
    id: z.number(),
    value: z.number(),
    percentage: z.number(),
});

export type BaseStatisticsOutputItem = z.infer<typeof BaseStatisticsOutputItemSchema>;